import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { CommonHeader } from "../common/CommonHeader";
import { POHeader } from "../POHeader/POHeader";
import { DataGrid } from "components/DataGrid/DataGrid";
import { splitPOColumnDefs } from "components/DataGrid/columnDefinitions";
import Button from "@mui/material/Button";
import { PAGE, PO_ITEM_STATUS, PO_STATUS } from "components/common/CONSTANTS";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { encryptString } from "components/common/EncryptDecrypt";
import { searchPO } from "redux/actions/searchPOAction";
import {
  handleCasesEdit,
  handlePalletsEdit,
  calculateTotalCases,
  calculateTotalBases,
  calculateTotalPallets,
  calculateTotalWagons,
} from "components/DataGrid/utils";
import { amendPoPatch } from "redux/actions/amendPOAction";
import { createPO } from "redux/actions/createPOAction";
import dayjs from "dayjs";
import { RESET_CREATE_PURCHASE_ORDER } from "redux/actions/action-type";
import { showNotificationDialog } from "redux/actions/notificationActions";

export const SplitPO = () => {
  const [sourcePO, setSourcePO] = useState();
  const [handball, setHandball] = useState();
  const [rounding, setRounding] = useState();
  const [overseas, setOverseas] = useState();
  const [orderDate, setOrderDate] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [comments, setComments] = useState();
  const [totalCases, setTotalCases] = useState();
  const [totalPallets, setTotalPallets] = useState();
  const [totalBases, setTotalBases] = useState();
  const [totalWagons, setTotalWagons] = useState();
  const [columnDefs, setColumnDefs] = useState(splitPOColumnDefs);
  const [itemsData, setItemsData] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { searchPOResponse, isSearchLoading } = useSelector(
    (state) => state.searchPO
  );
  const { isPOAmendPatchLoading, isPOAmendPatchSuccess } = useSelector(
    (state) => state.poAmendPatch
  );
  const { isCreatePOLoading, isCreatePOSuccess } = useSelector(
    (state) => state.createPO
  );
  const userType = useSelector((state) => state.user);
  const { orderId, noOfOrders } = location.state;

  const loginResponse = userType.loginResponse;

  useEffect(() => {
    const searchCriteria = {
      extOrderId: orderId,
    };
    callFetchOrders(searchCriteria);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (Object.hasOwn(searchPOResponse, "data")) {
      const { data } = searchPOResponse;
      const poData = data[0];
      const {
        isHandball,
        isQuantityRounded,
        isOverseas,
        orderDate,
        deliveryDate,
        userComments,
        totalCasesCount,
        totalPalletCount,
        totalBasesCount,
        totalWagonsCount,
      } = poData;

      setSourcePO({
        ...poData,
        shipToLocationId: poData.shipToLocationId,
        shipToLocationName: poData.shipToLocationName
          ? poData.shipToLocationName
          : null,
      });
      setHandball(isHandball);
      setRounding(isQuantityRounded);
      setOverseas(isOverseas);
      setOrderDate(() => ({
        0: dayjs(orderDate).format("YYYY-MM-DDTHH:mm:ss"),
      }));
      setDeliveryDate(() => ({
        0: dayjs(deliveryDate).format("YYYY-MM-DDTHH:mm:ss"),
      }));
      setComments(() => ({
        0: userComments,
      }));
      setTotalCases(() => ({
        0: totalCasesCount,
      }));
      setTotalPallets(() => ({
        0: totalPalletCount,
      }));
      setTotalBases(() => ({
        0: totalBasesCount,
      }));
      setTotalWagons(() => ({
        0: totalWagonsCount,
      }));
    }
  }, [searchPOResponse]);

  useEffect(() => {
    if (itemsData && sourcePO.palletPerWagon) {
      for (let i = 0; i <= noOfOrders; i++) {
        calculateTotalCases(i, itemsData, setTotalCases, rounding);
        calculateTotalPallets(i, itemsData, setTotalPallets, rounding);
        calculateTotalBases(i, itemsData, setTotalBases, rounding);
        calculateTotalWagons(
          i,
          itemsData,
          setTotalWagons,
          sourcePO.palletPerWagon,
          rounding
        );
      }
    }
  }, [itemsData, noOfOrders, rounding]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sourcePO) {
      const createdItems = sourcePO.items.map((item) => {
        const { casesPerLayer } = item;
        return {
          ...item,
          orderDate: sourcePO.orderDate,
          deliveryDate: sourcePO.deliveryDate,
          palletPerWagon: sourcePO.palletPerWagon,
          po1Cases: item.quantityOrdered,
          po1CasesRounded:
            Math.ceil(item.quantityOrdered / casesPerLayer) * casesPerLayer,
          po1Pallets: item.palletQuantity,
          po1PalletsRounded: Math.ceil(item.palletQuantity),
        };
      });
      setItemsData(createdItems);
    }
  }, [sourcePO, setItemsData]);

  useEffect(() => {
    if (noOfOrders) {
      // Create column definitions
      const dynamicColumns = Array.from({ length: noOfOrders }, (_, i) => ({
        headerName: `PO-${i + 1}`,
        children: [
          {
            headerName: "Order Qty (Cases)",
            field: rounding ? `po${i + 1}CasesRounded` : `po${i + 1}Cases`,
            editable: true,
            width: 80,
            minWidth: 80,
            flex: 1,
            filter: false,
            headerClass: "centered-header",
            cellStyle: { textAlign: "right" },
            valueSetter: (params) =>
              handleCasesEdit(params, `po${i + 1}`, setItemsData),
            cellEditor: "agNumberCellEditor",
          },
          {
            headerName: "Order Qty (Pallets)",
            field: rounding ? `po${i + 1}PalletsRounded` : `po${i + 1}Pallets`,
            editable: true,
            width: 80,
            minWidth: 80,
            flex: 1,
            filter: false,
            headerClass: "centered-header",
            cellStyle: { textAlign: "right" },
            valueSetter: (params) =>
              handlePalletsEdit(params, `po${i + 1}`, setItemsData),
            cellEditor: "agNumberCellEditor",
          },
        ],
      }));

      setColumnDefs([...splitPOColumnDefs, ...dynamicColumns]);
    }
  }, [noOfOrders, rounding]);

  useEffect(() => {
    if (isPOAmendPatchSuccess && isCreatePOSuccess) {
      setDialogOpen(true);
    }
  }, [isPOAmendPatchSuccess, isCreatePOSuccess]);

  const callFetchOrders = async (searchCriteria) => {
    const encryptedEmailId = await encryptString(loginResponse?.email);
    const payload = {
      params: {
        purchaseOrder: searchCriteria,
        userId: encryptedEmailId,
      },
      limit: 10,
      offset: 0,
    };
    dispatch(searchPO(payload));
  };

  const handleHandballToggle = () => {
    setHandball(!handball);
  };

  const handleRoundingToggle = () => {
    setRounding(!rounding);
  };

  const handleOverseasToggle = () => {
    setOverseas(!overseas);
  };

  const areAllDatesValid = () => {
    for (let i = 0; i < noOfOrders; i++) {
      if (!orderDate[i] || !deliveryDate[i]) {
        return false;
      }
      const orderDateObj = dayjs(orderDate[i]).startOf("day");
      const deliveryDateObj = dayjs(deliveryDate[i]).startOf("day");

      if (orderDateObj.isAfter(deliveryDateObj)) {
        return false;
      }
    }
    return true;
  };

  const handleConfirm = async () => {
    if (!areAllDatesValid()) {
      dispatch(
        showNotificationDialog(
          "Invalid Dates",
          "Please enter valid order & delivery dates and try again",
          "Ok"
        )
      );
      return;
    }

    const encryptedEmailId = await encryptString(loginResponse?.email);
    const payloadArray = [];
    for (let i = 0; i < noOfOrders; i++) {
      const caseKey = rounding ? `po${i + 1}CasesRounded` : `po${i + 1}Cases`;
      const palletKey = rounding
        ? `po${i + 1}PalletsRounded`
        : `po${i + 1}Pallets`;

      const updatedItems = itemsData
        .filter((item) => {
          return item[caseKey] !== undefined && item[caseKey] !== null;
        })
        .map((item) => {
          const { [caseKey]: cases, [palletKey]: pallets, ...rest } = item;
          return {
            ...rest,
            extOrderId: "",
            quantityOrdered: cases,
            palletQuantity: pallets,
            status: PO_ITEM_STATUS.CREATE,
            reasonCode: sourcePO.reasonCode,
          };
        })
        .map((item) => {
          return Object.fromEntries(
            Object.entries(item).filter(([key]) => !key.startsWith("po"))
          );
        });

      if (updatedItems.length === 0) continue;

      payloadArray.push({
        ...sourcePO,
        extOrderId: "",
        orderDate: orderDate[i],
        deliveryDate: deliveryDate[i],
        userComments: comments ? comments[i] : "",
        isHandball: handball,
        isOverseas: overseas,
        isQuantityRounded: rounding,
        status: PO_STATUS.CONFIRMED,
        totalCasesCount: totalCases[i],
        totalPalletCount: totalPallets[i],
        totalBasesCount: totalBases[i],
        totalWagonsCount: totalWagons[i],
        items: updatedItems,
      });
    }

    const amendPayload = payloadArray.shift();
    const headerData = {};
    Object.keys(amendPayload).forEach((key) => {
      if (
        key !== "items" &&
        JSON.stringify(amendPayload[key]) !== JSON.stringify(sourcePO[key])
      ) {
        headerData[key] = amendPayload[key];
      }
    });
    const amendedItems = amendPayload.items.map((item) => ({
      packId: item.packId,
      itemId: item.itemId,
      quantityOrdered: item.quantityOrdered,
      palletQuantity: item.palletQuantity,
      status: PO_STATUS.SOMS_AMENDED,
    }));
    const payload = {
      ...headerData,
      extOrderId: sourcePO.extOrderId,
      items: amendedItems,
      userId: encryptedEmailId,
    };

    if (payloadArray.length === 0) {
      dispatch(
        showNotificationDialog(
          "No Quantities Entered",
          "Please enter quantity for at least 1 item in a new PO",
          "Ok"
        )
      );
    } else {
      dispatch(amendPoPatch(payload, sourcePO.extOrderId));
      dispatch(createPO({ payloadArray: payloadArray }));
    }
  };

  return (
    <>
      <div className="mainPageStyling">
        {(isSearchLoading || isPOAmendPatchLoading || isCreatePOLoading) && (
          <Backdrop
            sx={{
              color: "#fff",
              flexDirection: "column",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
          >
            <CircularProgress color="inherit" />

            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Loading...
            </Typography>
          </Backdrop>
        )}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
            {PAGE.SPLIT_PO.label}
          </Typography>
        </div>

        {sourcePO && itemsData && (
          <>
            <div style={{ marginBottom: "10px" }} className="labelControl">
              <CommonHeader
                data={sourcePO}
                handball={handball}
                handleHandballToggle={handleHandballToggle}
                rounding={rounding}
                handleRoundingToggle={handleRoundingToggle}
                overseas={overseas}
                handleOverseasToggle={handleOverseasToggle}
              />

              <POHeader
                noOfOrders={noOfOrders}
                data={itemsData}
                rounding={rounding}
                comments={comments}
                setComments={setComments}
                orderDate={orderDate}
                setOrderDate={setOrderDate}
                deliveryDate={deliveryDate}
                setDeliveryDate={setDeliveryDate}
                totalCases={totalCases}
                totalPallets={totalPallets}
                totalBases={totalBases}
                totalWagons={totalWagons}
              />
            </div>
            <div style={{ width: "100%", height: "calc( 100vh - 360px)" }}>
              <DataGrid
                columnDefs={columnDefs}
                rowData={itemsData}
                defaultColDef={{
                  flex: 1,
                  sortable: false,
                  filter: false,
                  resizable: false,
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                  headerClass: "header-wrap",
                  autoSizeStrategy: { type: "fitCellContents" },
                }}
              />
            </div>

            <div className="parentPoButtons">
              <Button
                className="commonPOButtons"
                variant="contained"
                color="primary"
                onClick={handleConfirm}
                style={{
                  marginRight: "8px",
                }}
              >
                Confirm
              </Button>

              <Button
                className="commonPOButtons"
                variant="contained"
                color="secondary"
                onClick={() =>
                  navigate(PAGE.PO_SUMMARY.url, {
                    state: {
                      retainSearchCriteria: true,
                    },
                  })
                }
              >
                Back
              </Button>
            </div>
          </>
        )}

        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <div className="dialogStyling">
            <DialogTitle>PO Split</DialogTitle>
            <DialogContent>
              <DialogContentText>
                POs have been successfully split.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                className="commonPOButtons"
                variant="contained"
                color="primary"
                onClick={() => {
                  setDialogOpen(false);
                  dispatch({ type: RESET_CREATE_PURCHASE_ORDER });
                  navigate(PAGE.PO_SUMMARY.url, {
                    state: {
                      retainSearchCriteria: true,
                    },
                  });
                }}
              >
                OK
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    </>
  );
};
